
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignArrowDownRight as ObiSignArrowDownRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-arrow-down-right.js';
 
 
 

 
 export const ObiSignArrowDownRight = createComponent({
   react: React,
   tagName: 'obi-sign-arrow-down-right',
   elementClass: ObiSignArrowDownRightElement,
   events: {
     
   }
  });
 
 